import { Avatar, Flex, Text } from '@pinchenterprisesnpm/friday-ui'
import { PlusMoreAvatarsTextWrapper } from 'components/business/RowOfAvatars/style'

interface IRowOfAvatarsProps {
  avatars: string[]
  totalCount: number
}

export const RowOfAvatars = ({ avatars, totalCount }: IRowOfAvatarsProps) => {
  const remainingCount = totalCount - avatars.length

  return (
    <Flex>
      {avatars.map((avatar, i) => (
        <Avatar
          key={i}
          src={avatar}
          size="small"
          mr="-12px"
          backgroundColor="white"
          showFrame={true}
        />
      ))}
      {remainingCount > 0 && (
        <PlusMoreAvatarsTextWrapper
          justifyContent="center"
          alignItems="center"
          width="40px"
          height="40px"
        >
          <Text m={0} color="primary" fontSize="small">
            +{remainingCount}
          </Text>
        </PlusMoreAvatarsTextWrapper>
      )}
    </Flex>
  )
}
